import React from "react";
import LookupFormPage from "./LookupFormPage";

function GrantFormPage() {
  return (
    <LookupFormPage
      title="Grant"
      endpoint="/grants"
      listPath="/grants"
      fields={[
        { name: "name", label: "Name" },
        { name: "description", label: "Description", type: "textarea", required: false }
      ]}
    />
  );
}

export default GrantFormPage;
